import React from 'react';
import { Route, Switch } from 'react-router-dom';
import auth from '~/utils/routerAuth';

import Index from '~/pages/Index';
import Login from '~/pages/Login';
import Orders from '~/pages/Orders';
import Order from '~/pages/Order'; // new order
import Products from '~/pages/Products';
import Product from '~/pages/Product';
import Articles from '~/pages/Articles';
import Bundles from '~/pages/Bundles';
import Production from '~/pages/Production';
import RawMaterials from '~/pages/RawMaterials';
import Locations from '~/pages/Locations';
import Actions from '~/pages/Actions';
import Work from '~/pages/Work';
import Containers from '~/pages/Containers';
import CustomersNew from '~/pages/CustomersNew';
import Admin from '~/pages/Admin';
import Kits from '~/pages/Kits';
import Logs from '~/pages/Logs';
import Tasks from '~/pages/Tasks';
import Tools from '~/pages/Tools';
import Import3DCart from '~/pages/Import3DCart';
import IncomingDelivery from '~/pages/IncomingDelivery';
import Transactions from '~/pages/Transactions';
import Distributor from '~/pages/Distributor';
import Settings from '~/pages/Settings';
import DashboardConfig from '~/pages/DashboardConfig';
import DashboardInit from '~/pages/DashboardInit';
import DashboardConfigItem from '~/pages/DashboardConfig/Item';

const page404 = () => <p>404 page</p>;

export default (
  <Switch>
    <Route path="/" exact component={auth(Index, Login)} />
    <Route path="/admin" exact component={auth(Admin, Login)} />
    <Route path="/kits" exact component={auth(Kits, Login)} />
    <Route path="/logs" exact component={auth(Logs, Login)} />
    <Route path="/distributor" exact component={auth(Distributor, Login)} />
    <Route path="/customersNew" exact component={auth(CustomersNew, Login)} />
    <Route path="/settings" exact component={auth(Settings, Login)} />
    <Route path="/order" exact component={auth(Order, Login)} />
    <Route path="/orders" exact component={auth(Orders, Login)} />
    <Route path="/products" exact component={auth(Products, Login)} />
    <Route path="/product/:id" exact component={auth(Product, Login)} />
    <Route path="/articles" exact component={auth(Articles, Login)} />
    <Route path="/bundles" exact component={auth(Bundles, Login)} />
    <Route path="/production" exact component={auth(Production, Login)} />
    <Route path="/raw-materials" exact component={auth(RawMaterials, Login)} />
    <Route path="/locations" exact component={auth(Locations, Login)} />
    <Route path="/actions" exact component={auth(Actions, Login)} />
    <Route path="/work" exact component={auth(Work, Login)} />
    <Route path="/tools" exact component={auth(Tools, Login)} />
    <Route path="/tools/3dcart-import" exact component={auth(Import3DCart, Login)} />
    <Route path="/tools/incoming-delivery" exact component={auth(IncomingDelivery, Login)} />
    <Route path="/containers" exact component={auth(Containers, Login)} />
    <Route path="/transactions" exact component={auth(Transactions, Login)} />
    <Route path="/tasks" exact component={auth(Tasks, Login)} />
    <Route
      path="/dashboardconfig"
      exact
      component={auth(DashboardConfig, Login)}
    />
    <Route path="/dashboardinit" exact component={DashboardInit} />
    <Route
      path="/dashboardconfig/:id"
      exact
      component={auth(DashboardConfigItem, Login)}
    />
    <Route path="*" component={page404} status="404" />
  </Switch>
);



// WEBPACK FOOTER //
// ./app/routes.js